<template>
  <div class="courses-bg-color membership-layout-container pb-13">
    <div class="flex flex-row justify-between mb-6">
      <div class="text-2xl font-bold flex-1 campton-font course-title">
        <slot name="title"></slot>
        <!--  -->
      </div>
      <div>
        <slot name="tile-view-icons"></slot>
      </div>
    </div>
    <div
      class="flex courses-outer-wrapper"
      :class="[tileView === 'grid' ? 'flex-wrap' : 'flex-col']"
    >
      <slot name="courses-list"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Courses',
  props: {
    tileView: {},
    getThemeSettings: {},
  },
  data() {
    return {};
  },
  computed: {
    customCss() {
      return {
        '--template-courses-bg-color': this.themeSettings.body_section
          .backgroundColor,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss" scoped>
.courses-bg-color {
  background-color: var(--template-courses-bg-color);
}
.courses-outer-wrapper {
  margin: 0 -12px;
}
.campton-font {
  p {
    font-size: 24px !important;
    font-family: 'Campton Bold', sans-serif;
    font-weight: normal;
  }
}
</style>
<style lang="scss">
.membership-layout-container .custom-selectbox {
  .border-solid.cursor-pointer {
    font-size: 14px;
    height: 40px;
    background-color: #fff;
    border-color: #d5d8e5;
    border-radius: 6px;
    .select-none {
      padding: 0 12px;
      color: #000;
    }
  }
  svg {
    color: #191d3a;
    height: 20px;
    top: 2px;
    pointer-events: none;
  }
  .italic.select-none {
    display: none;
  }
}
.course-title.campton-font {
  p,
  .body-heading-color {
    font-size: 24px !important;
    font-family: Campton Bold, sans-serif;
    font-weight: 400;
  }
}
.pb-13 {
  padding-bottom: 3.25rem;
}
</style>
